export class ConfigDB {
    static data = {
      settings: {
        layout_type: 'ltr',
        layout_class: 'material-icon',
        sidebar: {
          iconType: 'stroke',
        },
        sidebar_setting: 'default-sidebar',
      },
      color: {
        primary_color:'#35bfbf',
        secondary_color: '#FF6150',
        third_color: '#FFCC33', 
        dark_color: '#31322D',
        light_color: '#F1F8F1',
        mix_background_layout: 'light',
      },
      router_animation: 'fadeIn',
    };
  }
  export default ConfigDB;